import { render } from "./ResetSuccess.vue?vue&type=template&id=48bb3e10&scoped=true"
import script from "./ResetSuccess.vue?vue&type=script&lang=js"
export * from "./ResetSuccess.vue?vue&type=script&lang=js"

import "./ResetSuccess.vue?vue&type=style&index=0&id=48bb3e10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bb3e10"]])

export default __exports__